import { useEffect } from 'react'
import { StringParam, useQueryParam } from 'use-query-params'

import { useQueryPage } from '@fourthwall/utils'

import type { State } from '../ThankYous.types'
import { useKudosOrdersQuery } from '../queries/useKudosOrdersQuery'
import { createOrdersQueryParams } from '../utils/createOrdersQueryParams'

export const useThankYous = () => {
  const [state, setState] = useQueryParam('state', StringParam)
  const activeTab = (state || 'WAITING') as State
  const { page, setPage } = useQueryPage()
  const params = createOrdersQueryParams(page, activeTab)
  const { kudosOrdersQuery, invalidateKudosOrdersQuery } = useKudosOrdersQuery([params], {
    keepPreviousData: true,
  })
  const data = kudosOrdersQuery.data?.orders || []
  const isLoading = kudosOrdersQuery.isFetching
  const noThankYous = kudosOrdersQuery.data?.contributions === 'NONE'

  useEffect(() => {
    setPage(undefined)
  }, [state])

  return {
    thankYous: {
      activeTab,
      data,
      isLoading,
      noThankYous,
      currentPage: page,
      totalPages: kudosOrdersQuery.data?.page.totalPages,
      setState,
      setPage,
      refetch: invalidateKudosOrdersQuery,
    },
  }
}
